import { login, logout } from "../../redux/slices/authSlice";
import instance, { instanceFile } from "../../ApiConfig";
import { URLS } from "../../ApiConfig/Urls";
import { distroySettting } from "../../redux/slices/settingslice";

const signup = async (userData) => {
  try {
    const response = await instance.post(URLS.GetAdmin, userData);
    if (response.status === 201) {
      return response.data;
    }
    throw new Error("Faild to Register the User");
  } catch (error) {
    console.error(error);
    throw error;
  }
};
const fetchUsers = async (id) => {
  try {
    const response = await instance.get(URLS.GetAdmin + id);
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch users");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchUsersList = async () => {
  try {
    const response = await instance.get(URLS.GetAdmin);
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch users");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchUsersById = async (Id) => {
  try {
    const response = await instance.get(URLS.GetAdmin + Id);
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch users");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchDriverList = async () => {
  try {
    const response = await instance.get(URLS.GetAdmin + URLS.GetDriver);
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Driver");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchPassengerList = async () => {
  try {
    const response = await instance.get(URLS.GetAdmin + URLS.GetPassenger);
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Passenger");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const getUserLogin = async (username, password) => {
  try {
    const response = await instance.post(URLS.GetAdminLogin, {
      email: username,
      password: password,
    });
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    throw error;
  }
};

const passwordReset = async (passwordReset) => {
  try {
    const response = await instance.post(URLS.GetPasswordReset, passwordReset); // Adjust the URL as needed
    if (response.status === 200) {
      console.log("Password reset successfully", "Reset Password");
      return response.data;
    } else {
      throw new Error("Failed to Rest Password");
    }
  } catch (error) {
    console.error("Error sending verification code:", error);
    throw error;
  }
};

const passwordChange = async (passwordReset) => {
  try {
    const response = await instance.put(URLS.GetPasswordChange, passwordReset); // Adjust the URL as needed
    if (response.status === 200) {
      return response.data;
    } else {
      throw new Error("Failed to Change password");
    }
  } catch (error) {
    console.error("Error sending verification code:", error);
    throw error;
  }
};

const UserUpdate = async (updatedUserData) => {
  return instanceFile
    .put(URLS.updateUserData, updatedUserData)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Failed to Update Driver");
      }
    })
    .catch((error) => {
      console.error("Error updating Driver:", error);
      throw error;
    });
};

const ProfileUpdate = async (id, updatedUserData) => {
  return instanceFile
    .put(URLS.GetAdmin + id + URLS.ProfileUser, updatedUserData)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Failed to Update Driver");
      }
    })
    .catch((error) => {
      console.error("Error updating Driver:", error);
      throw error;
    });
};
const PasswordUpdate = async (id, updatedUserData) => {
  return instanceFile
    .put(URLS.GetAdmin + id + URLS.PasswordUSer, updatedUserData)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Failed to Update Driver");
      }
    })
    .catch((error) => {
      console.error("Error updating Driver:", error);
      throw error;
    });
};

const DriverCreate = async (createDriverUserData) => {
  return instanceFile
    .post(URLS.GetAdmin + URLS.CreateDriver, createDriverUserData)
    .then((response) => {
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error("Failed to Update Driver");
      }
    })
    .catch((error) => {
      console.error("Error updating Driver:", error);
      throw error;
    });
};

const DriverUpdate = async (updatedDriverData, id) => {
  return instanceFile
    .put(URLS.GetAdmin + URLS.UpdateDriver + id, updatedDriverData)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Failed to Update Driver");
      }
    })
    .catch((error) => {
      console.error("Error updating Driver:", error);
      throw error;
    });
};

const UpdateDriverStatus = async (accountStatus, id) => {
  try {
    // Make the PUT request
    const response = await instanceFile.put(
      URLS.GetAdmin + URLS.UpdateDriverStatus + id + "/account-status",
      {
        accountStatus,
      },
    );

    // Check the response status
    if (response.status === 200) {
      return response.data; // Return the response data
    } else {
      throw new Error("Failed to Update Driver");
    }
  } catch (error) {
    // Log any errors that occur during the request
    console.error("Error updating Driver:", error);
    throw error; // Rethrow the error for further handling if needed
  }
};

const deleteDriver = async (id) => {
  try {
    const response = await instance.delete(
      URLS.GetAdmin + URLS.DeleteDriver + id,
    );
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch users");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const AddVehicleToDriver = async (addedData) => {
  console.log("hi", addedData);
  try {
    const response = await instance.post(
      URLS.GetAdmin + URLS.AddVehicleToDriver,
      addedData,
    );

    // console.log("response", response.data.data);
    // console.log("status", response.status);
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    throw error;
  }
};

const SearchDrivers = async (name) => {
  console.log("hi", name);
  try {
    const response = await instance.get(URLS.GetAdmin + URLS.GetDriverByName, {
      params: { name },
    });

    console.log("response", response.data);
    // console.log("status", response.status);
    if (response.status === 200) {
      return response.data;
    }
    return null;
  } catch (error) {
    throw error;
  }
};

const PassengerCreate = async (createPassengerUserData) => {
  return instanceFile
    .post(URLS.GetAdmin + URLS.CreatePassenger, createPassengerUserData)
    .then((response) => {
      if (response.status === 201) {
        return response.data;
      } else {
        throw new Error("Failed to Update Passenger");
      }
    })
    .catch((error) => {
      console.error("Error updating Passenger:", error);
      throw error;
    });
};
const PassengerUpdate = async (updatedPassengerData, id) => {
  return instanceFile
    .put(URLS.GetAdmin + URLS.UpdatePassenger + id, updatedPassengerData)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Failed to Update Passenger");
      }
    })
    .catch((error) => {
      console.error("Error updating Passenger:", error);
      throw error;
    });
};

const deletePassenger = async (id) => {
  try {
    const response = await instance.delete(
      URLS.GetAdmin + URLS.DeletePassenger + id,
    );
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Passenger");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchDispatcherList = async () => {
  try {
    const response = await instance.get(URLS.GetAdmin);
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Dispatcher");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const DispatcherCreate = async (createDispatcherUserData) => {
  return instance
    .post(URLS.GetAdmin, createDispatcherUserData)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Failed to Update Dispatcher");
      }
    })
    .catch((error) => {
      console.error("Error updating Dispatcher:", error);
      throw error;
    });
};
const DispatcherUpdate = async (updatedDispatcherData, id) => {
  return instance
    .put(URLS.GetAdmin + id, updatedDispatcherData)
    .then((response) => {
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Failed to Update Dispatcher");
      }
    })
    .catch((error) => {
      console.error("Error updating Dispatcher:", error);
      throw error;
    });
};

const deleteDispatcher = async (id) => {
  try {
    const response = await instance.put(
      URLS.GetAdmin + id + URLS.DeactiveAdmin,
    );
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Dispatcher");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const ActivateDispatcher = async (id) => {
  try {
    const response = await instance.put(
      URLS.GetAdmin + id + URLS.ActivateAdmin,
    );
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch Dispatcher");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchActiveDrivers = async (status) => {
  try {
    // console.log(URLS.GetAdmin + URLS.GetActiveDrivers + status);
    const response = await instance.get(
      URLS.GetAdmin + URLS.GetActiveDrivers + status,
    );
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch users");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const fetchDriversCount = async (status) => {
  try {
    // console.log(URLS.GetAdmin + URLS.GetActiveDrivers + status);
    const response = await instance.get(URLS.GetAdmin + URLS.GetDriverCount);
    if (response.status === 200) {
      return response.data;
    }

    throw new Error("Failed to fetch users");
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const authenticate = (user, dispatch, next) => {
  if (typeof window !== "undefined") {
    dispatch(login(user));
    next();
  }
};

const Logout = (dispatch) => {
  dispatch(logout());
  dispatch(distroySettting());
};

export default {
  signup,
  getUserLogin,
  authenticate,
  Logout,
  fetchUsers,
  passwordReset,
  UserUpdate,
  passwordChange,
  fetchUsersList,
  fetchDriverList,
  fetchDispatcherList,
  fetchPassengerList,
  fetchActiveDrivers,
  DriverCreate,
  DriverUpdate,
  deleteDriver,
  PassengerCreate,
  PassengerUpdate,
  deletePassenger,
  DispatcherCreate,
  deleteDispatcher,
  DispatcherUpdate,
  AddVehicleToDriver,
  ActivateDispatcher,
  fetchUsersById,
  ProfileUpdate,
  PasswordUpdate,
  fetchDriversCount,
  UpdateDriverStatus,
  SearchDrivers,
};
